abp.message.error = function (message, title, isHtml) {
    abp.notify.error(message, title);
};

function hideChatSupportButton() {
    $('.octachatAppClose').hide();
}

function showChatSupportButton() {
    $('.octachatAppClose').show();
}